import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import {translate} from 'react-admin';

class PaymentButton extends Component {
    
    handleClick = (event) => {
        event.stopPropagation();
        const { record } = this.props;
        window.location = '#/payments/create?category='+record.category+'&purchase_id='+record.id+'&vendor_id='+record.vendorId+'&total='+record.total_price+'&total_cny='+record.total_price_cny;  
    }
    handleShipOrderClick = (event) => {
        event.stopPropagation();
        const { record } = this.props;
        let vendorId = record.vendorId===null?'':record.vendorId;
        window.location = '#/purchases/create?category=shipping&product_id='+record.productId+'&vendor_id='+record.vendorId;  
    }

    render() {
        return (
            <div>
                <Button label="payment" onClick={this.handleClick} color="primary" variant="raised">{this.props.translate('resources.purchases.actions.payment')}</Button>
            </div>
            
        );
    }
}

PaymentButton.propTypes = {
    record: PropTypes.object,

};

const enhance = compose(
    translate
);

export default enhance(PaymentButton);